import styled from "styled-components";

const ReceiptPageWrapper = styled.div`
  --rp-primary: ${props => props.$primary || "#1F3B6F"};
  --rp-secondary: ${props => props.$secondary || "#4CAF50"};
  --rp-bg: #f4f6fb;
  --rp-card: #ffffff;
  --rp-text: #1e293b;
  --rp-muted: #64748b;

  min-height: ${props => (props.$embedded ? "auto" : "100vh")};
  overflow-x: hidden;
  background: var(--rp-bg);
  color: var(--rp-text);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;

  .rp-preview-banner {
    background: #fef3c7;
    color: #92400e;
    text-align: center;
    padding: 8px 12px;
    font-size: 13px;
    font-weight: 600;
  }

  .rp-shell {
    max-width: 420px;
    margin: 0 auto;
    padding: 0 16px calc(32px + env(safe-area-inset-bottom, 0px));
  }

  .rp-header {
    background: linear-gradient(145deg, var(--rp-primary), var(--rp-secondary));
    border-radius: 0 0 24px 24px;
    padding: 28px 20px 24px;
    color: #fff;
    text-align: center;
    box-shadow: 0 12px 30px rgba(15, 23, 42, 0.12);
    margin: 0 -16px 20px;
  }

  .rp-logo {
    width: 72px;
    height: 72px;
    border-radius: 18px;
    object-fit: cover;
    background: rgba(255, 255, 255, 0.2);
    border: 2px solid rgba(255, 255, 255, 0.35);
    margin-bottom: 12px;
  }

  .rp-logo-fallback {
    width: 72px;
    height: 72px;
    border-radius: 18px;
    background: rgba(255, 255, 255, 0.2);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 12px;
  }

  .rp-store-name {
    font-size: 22px;
    font-weight: 700;
    margin: 0 0 6px;
    line-height: 1.2;
  }

  .rp-tagline {
    margin: 0;
    font-size: 14px;
    opacity: 0.92;
  }

  .rp-card {
    background: var(--rp-card);
    border-radius: 16px;
    padding: 16px;
    box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
    margin-bottom: 16px;
  }

  .rp-receipt-frame {
    position: relative;
    border-radius: 12px;
    overflow: hidden;
    background: #f8fafc;
    border: 1px solid #e2e8f0;
  }

  .rp-receipt-img {
    width: 100%;
    display: block;
    max-height: 420px;
    object-fit: contain;
    background: #fff;
  }

  .rp-receipt-pdf {
    width: 100%;
    height: 70vh;
    border: none;
    display: block;
  }

  .rp-pdf-mobile {
    padding: 24px 18px 22px;
    text-align: center;
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(248, 250, 252, 1) 100%
    );
    border: 2px dashed rgba(31, 59, 111, 0.18);
  }

  .rp-pdf-title {
    margin: 0 0 8px;
    font-size: 17px;
    font-weight: 700;
    color: var(--rp-text);
  }

  .rp-pdf-icon {
    width: 64px;
    height: 64px;
    margin: 0 auto 14px;
    border-radius: 18px;
    background: linear-gradient(145deg, var(--rp-primary), var(--rp-secondary));
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.16);
  }

  .rp-pdf-icon svg {
    width: 30px;
    height: 30px;
    stroke: #fff;
    fill: none;
  }

  .rp-pdf-mobile p {
    margin: 0 0 18px;
    font-size: 14px;
    color: var(--rp-muted);
    line-height: 1.5;
  }

  .rp-view-receipt-btn {
    display: flex !important;
    width: 100%;
    min-height: 52px;
    align-items: center;
    justify-content: center;
    gap: 10px;
    border: none;
    border-radius: 14px;
    padding: 14px 18px;
    font-size: 16px !important;
    font-weight: 700;
    line-height: 1.3;
    letter-spacing: 0.01em;
    white-space: normal;
    text-align: center;
    color: #fff !important;
    text-decoration: none !important;
    background: linear-gradient(135deg, var(--rp-primary), var(--rp-secondary));
    box-shadow: 0 10px 24px rgba(15, 23, 42, 0.2);
    transition: transform 0.15s ease, box-shadow 0.15s ease;
    box-sizing: border-box;
  }

  .rp-view-receipt-btn:active {
    transform: scale(0.98);
    box-shadow: 0 6px 16px rgba(15, 23, 42, 0.18);
  }

  .rp-view-receipt-btn .rp-btn-label,
  .rp-view-receipt-btn .rp-btn-icon {
    color: #fff !important;
  }

  .rp-actions {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 14px;
  }

  .rp-action-row {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: stretch;
    gap: 10px;
    margin-top: 8px;
    width: 100%;
  }

  .rp-action-row .rp-email-submit,
  .rp-action-row .rp-btn.rp-action-btn {
    flex: 1 1 0;
    min-width: 0;
    width: auto !important;
    max-width: none;
    margin: 0;
    min-height: 48px;
    padding: 12px 8px;
    font-size: 14px !important;
    line-height: 1.2;
  }

  .rp-action-row .rp-btn.rp-action-btn {
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    gap: 6px;
  }

  .rp-action-row .rp-btn-label {
    font-size: 13px;
    line-height: 1.2;
  }

  .rp-btn {
    display: flex !important;
    width: 100%;
    min-height: 48px;
    align-items: center;
    justify-content: center;
    gap: 8px;
    border: none;
    border-radius: 12px;
    padding: 13px 16px;
    font-size: 15px !important;
    font-weight: 600;
    line-height: 1.3;
    white-space: normal;
    text-align: center;
    cursor: pointer;
    text-decoration: none !important;
    box-sizing: border-box;
    transition: transform 0.15s ease, opacity 0.15s ease;
  }

  .rp-btn-label {
    display: inline-block;
    color: inherit;
    font-size: inherit;
    font-weight: inherit;
    line-height: inherit;
  }

  .rp-btn-icon {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .rp-btn-icon svg {
    width: 18px;
    height: 18px;
  }

  .rp-btn-icon svg path {
    stroke: currentColor;
    fill: none;
  }

  .rp-btn-icon svg circle {
    fill: currentColor;
    stroke: none;
  }

  .rp-btn:active {
    transform: scale(0.98);
  }

  .rp-btn-primary {
    background: var(--rp-primary);
    color: #fff;
  }

  .rp-btn-secondary {
    background: #0f172a;
    color: #fff !important;
  }

  .rp-btn-outline {
    background: #fff;
    color: var(--rp-primary) !important;
    border: 1.5px solid var(--rp-primary);
  }

  .rp-btn-trustpilot {
    background: #00b67a;
    color: #fff !important;
  }

  .rp-section-title {
    font-size: 15px;
    font-weight: 700;
    text-align: center;
    margin: 0 0 14px;
    color: var(--rp-text);
  }

  .rp-social-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
  }

  .rp-social-btn {
    width: 48px;
    height: 48px;
    border-radius: 14px;
    border: none;
    color: #fff !important;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(15, 23, 42, 0.12);
  }

  .rp-social-btn i {
    color: #fff !important;
    font-size: 18px;
    line-height: 1;
  }

  .rp-feedback {
    background: #f8fafc;
    border-radius: 14px;
    padding: 18px 12px;
  }

  .rp-emoji-row {
    display: flex;
    justify-content: center;
    gap: 10px;
    flex-wrap: wrap;
  }

  .rp-emoji-btn {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 8px;
    cursor: pointer;
  }

  .rp-emoji-btn img {
    width: 32px;
    height: 32px;
    display: block;
  }

  .rp-promo-section {
    overflow: hidden;
  }

  .rp-promo-single,
  .rp-promo-slider-wrap {
    width: 100%;
  }

  .rp-promo-swiper {
    width: 100%;
    padding-bottom: 28px;
  }

  .rp-promo-swiper .swiper-slide {
    height: auto;
  }

  .rp-promo-swiper .swiper-pagination-bullet {
    background: #cbd5e1;
    opacity: 1;
  }

  .rp-promo-swiper .swiper-pagination-bullet-active {
    background: var(--rp-primary);
  }

  .rp-promo-item {
    text-align: center;
    cursor: pointer;
    width: 100%;
  }

  .rp-promo-item img,
  .rp-promo-placeholder {
    width: 100%;
    aspect-ratio: 16 / 9;
    border-radius: 12px;
    display: block;
    margin: 0 auto;
  }

  .rp-promo-item img {
    object-fit: cover;
    background: #e2e8f0;
  }

  .rp-promo-placeholder {
    background: linear-gradient(145deg, var(--rp-primary), var(--rp-secondary));
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    font-size: 15px;
    font-weight: 600;
    text-align: center;
    line-height: 1.35;
  }

  .rp-promo-name {
    font-size: 13px;
    margin-top: 10px;
    color: var(--rp-muted);
    font-weight: 600;
    line-height: 1.35;
    padding: 0 4px;
  }

  .rp-app-badges {
    display: flex;
    justify-content: center;
    gap: 12px;
    flex-wrap: wrap;
  }

  .rp-app-badges img {
    height: 40px;
    cursor: pointer;
  }

  .rp-loading {
    text-align: center;
    padding: 48px 16px;
    color: var(--rp-muted);
  }

  .rp-empty-receipt {
    padding: 48px 16px;
    text-align: center;
    color: var(--rp-muted);
    font-size: 14px;
  }

  .rp-email-capture {
    text-align: center;
  }

  .rp-email-capture--inline {
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid #e2e8f0;
  }

  .rp-email-title {
    margin: 0 0 14px;
    font-size: 15px;
    font-weight: 700;
    line-height: 1.3;
    color: var(--rp-text);
  }

  .rp-email-field {
    margin-bottom: 16px;
    text-align: left;
  }

  .rp-email-input {
    width: 100%;
    border: 1.5px solid #dbe3ef;
    border-radius: 16px;
    padding: 16px 18px;
    font-size: 16px;
    font-weight: 600;
    color: var(--rp-text);
    background: #fff;
    box-sizing: border-box;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
  }

  .rp-email-input:focus {
    outline: none;
    border-color: var(--rp-primary);
    box-shadow: 0 0 0 3px rgba(31, 59, 111, 0.1);
  }

  .rp-email-input::placeholder {
    color: #94a3b8;
    font-weight: 600;
  }

  .rp-email-input:disabled {
    background: #f8fafc;
    color: #94a3b8;
  }

  .rp-email-consent {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    margin: 0 0 18px;
    text-align: left;
    cursor: pointer;
  }

  .rp-email-consent input[type="checkbox"] {
    width: 20px;
    height: 20px;
    margin: 2px 0 0;
    accent-color: var(--rp-primary);
    flex-shrink: 0;
    cursor: pointer;
  }

  .rp-email-consent-text {
    font-size: 13px;
    line-height: 1.5;
    color: var(--rp-muted);
  }

  .rp-privacy-link {
    display: inline;
    padding: 0;
    border: none;
    background: none;
    color: var(--rp-primary);
    font: inherit;
    font-weight: 600;
    text-decoration: underline;
    text-underline-offset: 2px;
    cursor: pointer;
  }

  .rp-privacy-link:hover {
    opacity: 0.85;
  }

  .rp-email-error {
    display: block;
    margin-top: 6px;
    font-size: 12px;
    color: #dc2626;
    text-align: left;
  }

  .rp-email-submit {
    width: 100%;
    min-height: 50px;
    border: none;
    border-radius: 14px;
    padding: 14px 18px;
    font-size: 16px;
    font-weight: 700;
    color: #fff !important;
    cursor: pointer;
    background: linear-gradient(135deg, var(--rp-primary), var(--rp-secondary));
    box-shadow: 0 8px 20px rgba(15, 23, 42, 0.14);
    transition: transform 0.15s ease, opacity 0.15s ease;
  }

  .rp-email-submit:active:not(:disabled) {
    transform: scale(0.98);
  }

  .rp-email-submit:disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }

  .rp-email-spinner {
    width: 22px;
    height: 22px;
    border: 2.5px solid rgba(255, 255, 255, 0.35);
    border-top-color: #fff;
    border-radius: 50%;
    animation: rp-email-spin 0.7s linear infinite;
    display: inline-block;
  }

  @keyframes rp-email-spin {
    to {
      transform: rotate(360deg);
    }
  }

  .rp-email-success-text {
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
    color: var(--rp-muted);
  }

  ${props =>
    props.$embedded &&
    `
    font-size: 13px;

    .rp-preview-banner {
      padding: 6px 10px;
      font-size: 11px;
    }

    .rp-shell {
      max-width: 100%;
      padding: 0 10px 14px;
    }

    .rp-header {
      padding: 18px 14px 16px;
      margin: 0 -10px 14px;
      border-radius: 0 0 18px 18px;
    }

    .rp-logo,
    .rp-logo-fallback {
      width: 52px;
      height: 52px;
      border-radius: 14px;
      font-size: 20px;
      margin-bottom: 8px;
    }

    .rp-store-name {
      font-size: 17px;
    }

    .rp-tagline {
      font-size: 12px;
    }

    .rp-card {
      padding: 12px;
      margin-bottom: 12px;
      border-radius: 14px;
    }

    .rp-section-title {
      font-size: 13px;
      margin-bottom: 10px;
    }

    .rp-btn {
      min-height: 40px;
      padding: 10px 12px;
      font-size: 13px !important;
      border-radius: 10px;
    }

    .rp-social-btn {
      width: 40px;
      height: 40px;
      font-size: 15px;
      border-radius: 12px;
    }

    .rp-social-btn i {
      font-size: 15px;
    }

    .rp-emoji-btn img {
      width: 26px;
      height: 26px;
    }

    .rp-app-badges img {
      height: 32px;
    }

    .rp-email-title {
      font-size: 13px;
      margin-bottom: 10px;
    }

    .rp-email-input {
      padding: 12px 14px;
      font-size: 14px;
      border-radius: 12px;
    }

    .rp-email-submit {
      min-height: 42px;
      font-size: 14px;
      border-radius: 12px;
    }

    .rp-action-row .rp-btn {
      min-height: 42px;
      font-size: 13px !important;
    }

    .rp-empty-receipt,
    .rp-pdf-mobile {
      padding: 20px 12px;
    }

    .rp-pdf-title {
      font-size: 15px;
    }

    .rp-receipt-img {
      max-height: 220px;
    }
  `}

  @media (max-width: 480px) {
    .rp-shell {
      max-width: 100%;
      padding: 0 12px calc(24px + env(safe-area-inset-bottom, 0px));
    }

    .rp-header {
      padding: 20px 14px 18px;
      margin: 0 -12px 14px;
      border-radius: 0 0 20px 20px;
    }

    .rp-logo,
    .rp-logo-fallback {
      width: 56px;
      height: 56px;
      border-radius: 16px;
      font-size: 22px;
      margin-bottom: 10px;
    }

    .rp-store-name {
      font-size: 18px;
    }

    .rp-tagline {
      font-size: 13px;
    }

    .rp-card {
      padding: 12px;
      margin-bottom: 12px;
      border-radius: 14px;
    }

    .rp-section-title {
      font-size: 14px;
      margin-bottom: 12px;
    }

    .rp-receipt-img {
      max-height: 280px;
    }

    .rp-receipt-pdf {
      height: 52vh;
    }

    .rp-pdf-mobile {
      padding: 18px 14px 16px;
    }

    .rp-pdf-title {
      font-size: 16px;
    }

    .rp-pdf-icon {
      width: 44px;
      height: 44px;
    }

    .rp-view-receipt-btn {
      min-height: 42px;
      padding: 11px 14px;
      font-size: 14px;
    }

    .rp-btn {
      min-height: 42px;
      padding: 11px 14px;
      font-size: 14px !important;
      border-radius: 10px;
    }

    .rp-btn-icon,
    .rp-btn-icon svg {
      width: 16px;
      height: 16px;
    }

    .rp-social-btn {
      width: 42px;
      height: 42px;
      font-size: 16px;
      border-radius: 12px;
    }

    .rp-social-btn i {
      font-size: 16px;
    }

    .rp-emoji-btn {
      padding: 6px;
    }

    .rp-emoji-btn img {
      width: 28px;
      height: 28px;
    }

    .rp-app-badges img {
      height: 34px;
    }

    .rp-email-title {
      font-size: 14px;
    }

    .rp-email-input {
      padding: 12px 14px;
      font-size: 15px;
      border-radius: 12px;
    }

    .rp-email-submit {
      min-height: 44px;
      font-size: 15px;
      border-radius: 12px;
    }

    .rp-action-row {
      gap: 8px;
    }

    .rp-action-row .rp-btn {
      min-height: 44px;
      padding: 10px 8px;
      font-size: 13px !important;
    }

    .rp-promo-name {
      font-size: 12px;
      margin-top: 8px;
    }
  }
`;

export const ReceiptPreviewFrame = styled.div`
  border: 8px solid #1e293b;
  border-radius: 24px;
  overflow: hidden;
  box-shadow: 0 16px 32px rgba(15, 23, 42, 0.12);
  max-height: min(720px, 72vh);
  overflow-y: auto;
  background: #fff;
  width: 300px;
  max-width: 100%;
  margin: 0 auto;

  @media (max-width: 768px) {
    width: min(280px, calc(100vw - 48px));
    border-width: 6px;
    border-radius: 20px;
    max-height: min(560px, 58vh);
  }
`;

export const ReceiptSettingsLayout = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 300px;
  gap: 24px;
  align-items: start;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 768px) {
    gap: 16px;
  }
`;

export default ReceiptPageWrapper;
